'use client';

import { createContext } from 'react';

import { CookieConsentContextType } from '../types';

const CookieConsentContext = createContext<CookieConsentContextType | undefined>(undefined);

export default CookieConsentContext;
